// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.generatedlease.GeneratedLeaseWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GeneratedLeaseFeedbackRequestDto } from '../..';

export const GeneratedLeaseWebApiHandler_saveFeedback_Path = '/api/web/v1/generatedLease/saveFeedback';

/**
 * save generated lease feedback for landlord
 */
export const GeneratedLeaseWebApiHandler_saveFeedback = (
  postData: GeneratedLeaseFeedbackRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GeneratedLeaseFeedbackRequestDto, void>(
    {
      endpoint: GeneratedLeaseWebApiHandler_saveFeedback_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};
